
import {productsFor} from "../product/products.js";
import {loadProducts} from "../network/fetcher.js";
import {MINUTE} from "../util/consts.js";
import * as utc from "../util/utc.js";
import {ø} from "../util/objects.js";
import {report} from "../report.js";
import {$} from "../util/seq.js";

let id = 0;
// Some hacky stuff to ensure only one download can be in progress at a time.
let downloadsInProgress = 0;
// Currently active task to auto refresh data.
let autoRefresher = NaN;

function buildLayers(agents, sharedStore, sessionStore, cancel) {
    report.status("Downloading...");

    const {layerManagerAgent, primaryLayerAgent, overlayLayerAgent, activeLayerAgent} = agents;
    const timerName = `build layers #${id++}`;
    const attr = ø(sharedStore.getAll(), sessionStore.getAll());
    return Promise.all(productsFor(attr)).then(products => {
        downloadsInProgress++;
        console.time(timerName);

        return loadProducts(products, cancel).then(products => {
            if (cancel.requested) {
                return;
            }
            primaryLayerAgent.submit(products[0]);
            overlayLayerAgent.submit(products[1]);
            activeLayerAgent.submit(products[1] ?? products[0]);
        }).catch(err => {
            report.error(err);
            if (cancel.requested) {
                return;
            }
            primaryLayerAgent.submit(products[0]);
            overlayLayerAgent.submit(products[1]);
            activeLayerAgent.submit(products[1] ?? products[0]);
        }).finally(() => {
            downloadsInProgress--;
            console.timeEnd(timerName);
        });

    }).finally(() => {
        // Re-download fresh data periodically.
        // UNDONE: this doesn't work for OSCAR data because the catalog is not refreshed.
        clearInterval(autoRefresher);
        autoRefresher = sharedStore.get("time_cursor") === "now" ?
            setInterval(
                () => layerManagerAgent.submit(function() {
                    return buildLayers(agents, sharedStore, sessionStore, this.cancel);
                }),
                30 * MINUTE) :
            NaN;
    });
}

export function defineLayerManager(agents, sharedStore, sessionStore) {
    const {layerManagerAgent} = agents;

    function downloadLayers() {
        layerManagerAgent.submit(function() {
            return buildLayers(agents, sharedStore, sessionStore, this.cancel);
        });
    }
    sharedStore.on($`change:time_cursor change:z_level change:animation_type change:overlay_type`, downloadLayers);
    sessionStore.on($`change:hd_enabled`, downloadLayers);
}

/**
 * Modifies the configuration to navigate to the chronologically next or previous data layer.
 */
export function navigate(time_cursor, layer, op) {
    if (downloadsInProgress > 0) {
        console.log("Download in progress--ignoring nav request.");
        return;
    }
    const next = layer?.[op]?.();
    if (next !== undefined) {
        time_cursor.set(utc.date(next).toISOString());
    }
}
